// Types
import { RootState } from 'types/RootState.types';

export const getAuth0CallbackCallbackErrorSelector = (state: RootState) => state.auth0Callback?.callbackError;
